import "@amzn/awsui-global-styles/polaris.css";
import React from "react";
import { BrowserRouter, Route, HashRouter, Switch } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PageNotFound } from "src/components/errors/PageNotFound";
import WIMOutput from "src/components/wim-output/index";
import ServiceHomepage from "./home";

export class App extends React.Component {
  render() {
    return (
      <>
        <div className="awsui">
          <BrowserRouter>
          {/* Use HashRouter instead of BrowserRouter in development */}
          {/* <HashRouter> */}
            <Switch>
              <Route exact path="/" component={ServiceHomepage} />
              <Route exact path="/wim/output/:workitemId" component={WIMOutput} />
              <Route path="*" component={PageNotFound} />
            </Switch>
          {/* </HashRouter> */}
          </BrowserRouter>
        </div>
        <div>
          <ToastContainer className="custom-toast" position={toast.POSITION.TOP_CENTER} />
        </div>
      </>
    );
  }
}

export default App;
